import { CompanyCreateRequest } from '../domain/company'
import { ICompanyRepository } from '../domain/ICompanyRepository'

export class CreateCompanyUseCase {
    constructor(private repository: ICompanyRepository) {}

    async execute(
        company: CompanyCreateRequest
    ): Promise<CompanyCreateRequest> {
        return this.repository.create(company)
    }
}
